import { Button } from '@zep-us/zus';
import { CheckSmallCircleFillIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
interface QuizBankSelectionBarProps {
  selectedCount: number;
  onAdd: () => void;
  className?: string;
}

/** 하단 담기 바. 개수는 왼쪽이 말하고 버튼 문구는 고정이다. */
export const QuizBankSelectionBar = ({
  selectedCount,
  onAdd,
  className
}: QuizBankSelectionBarProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className={cn('flex shrink-0 flex-wrap items-center gap-xs border-t border-alternative bg-default px-md py-md tablet-sm:flex-nowrap tablet-sm:px-lg', className)} data-sentry-component="QuizBankSelectionBar" data-sentry-source-file="QuizBankSelectionBar.tsx">
      <span className="text-body-md-semibold text-alternative">
        {t('build:quizBank.footer.selectedCount', {
        n: selectedCount
      })}
      </span>

      <div className="ml-auto flex items-center gap-xs">
        <Button className="max-tablet-sm:px-md" size="lg" variant="contained" disabled={selectedCount === 0} leftSlot={<CheckSmallCircleFillIcon size="md" />} onClick={onAdd} data-sentry-element="Button" data-sentry-source-file="QuizBankSelectionBar.tsx">
          {t('build:quizBank.footer.add')}
        </Button>
      </div>
    </div>;
};